import React, { useState } from 'react';
import { CrudMasterDetailView, GridView, CompositeView, CrudContext, CrudMasterDetailViewPaginated } from '@digital/ui';
import { getAllUsuarios, createUsuarioTerceiro, Usuario } from '@app/api/usuario';
import CreateUserForm from './CreateUserForm';
import UsuarioForm from './UsuarioForm';
import { hasPermission } from '@app/helpers/permissions';
const Usuario = () => {
  const [GetAllItems, setGetAllItems] = useState(() => {
    return getAllUsuarios;
  });

  const handleUpdate = () => {
    setGetAllItems(() => () => Promise.resolve(undefined));
    setGetAllItems(() => getAllUsuarios);
  };

  const getInfoComplementarDescription = (item: Usuario) => {
    if (item.tipoUsuarioCodigo == 1) return ' - ' + item.identificadorErp;
    else if (item.tipoUsuarioCodigo == 2) return ' - ' + item.fornecedor;
    else return "";
  }

  const getInfoComplementarDescriptionExtractor = (item: Usuario) => {
    if (item.tipoUsuarioCodigo == 1) return ': ' + item.identificadorErp;
    else if (item.tipoUsuarioCodigo == 2) return ': ' + item.fornecedor;
    else return "";
  }

  return (
    <CrudMasterDetailViewPaginated
      pageSize={100}
      icon="profile-user_male_circle"
      createItem={hasPermission(['USUARIO_CADASTRAR_TERCEIRO']) ? createUsuarioTerceiro : undefined}
      getAllItems={GetAllItems}
      disableNotification={true}
      filterPredicate={(item, value) =>
        ((item.nome && item.nome.toLowerCase().includes(value.toLowerCase())) ||
          (item.status && item.status.toLowerCase().startsWith(value.toLowerCase())) ||
          (item.username && item.username.toLowerCase().includes(value.toLowerCase())) ||
          (item.tipoUsuario && item.tipoUsuario.toLowerCase().startsWith(value.toLowerCase())) ||
          (item.fornecedor && item.fornecedor.toLowerCase().startsWith(value.toLowerCase())) ||
          (item.identificadorErp && item.identificadorErp.toLowerCase().includes(value.toLowerCase()))) == true
      }
      detailTitleExtractor={item =>
        item.nome +
        ' - ' +
        item.status +
        ' - ' +
        item.tipoUsuario +
        getInfoComplementarDescription(item)
      }
      titleExtractor={d => d.nome + ' - ' + d.status}
      descriptionExtractor={d => d.tipoUsuario + getInfoComplementarDescriptionExtractor(d)} >
      <CrudContext.Consumer>
        {({ selectedItem }) => {
          if (selectedItem) {
            return (
              <CompositeView>
                <GridView noform>
                  <UsuarioForm onUpdate={handleUpdate} />
                </GridView>
              </CompositeView>
            );
          } else {
            return (
              <CompositeView>
                <GridView noform>
                  <CreateUserForm />
                </GridView>
              </CompositeView>
            );
          }
        }}
      </CrudContext.Consumer>
    </CrudMasterDetailView >
  );
};
export default Usuario;
